﻿import $ from "jquery";

const pageScrollWidth = 16,
	arrowHalfWidth = 12;

const directionClass = {
	top: "ccs-logo-ls-popup-top",
	bottom: "ccs-logo-ls-popup-bottom",
	left: "ccs-logo-ls-popup-left",
	right: "ccs-logo-ls-popup-right"
};

export default class PositionController {
	constructor($icon, $popup, hoverDirection) {
		this.$popup = $popup;
		this.$icon = $icon;

		this.hoverDirection = hoverDirection;
	}

	init() {
		this.collectScreenValues();
		this.clearHoverStyles();

		this.$popup
			.css({
				top: "-99999px",
				left: "-99999px"
			})
			.show();

		this.guessHoverDirection();

		const hoverPosition = this.hoverDirection === "left" || this.hoverDirection === "right"
			? this.getHoverPositionOnHorizontalAxis()
			: this.getHoverPositionOnVerticalAxis();

		this.$popup.css({
			top: hoverPosition.Top,
			left: hoverPosition.Left,
			visibility: "visible",
			backgroundPosition: hoverPosition.arrowBgPositionX + " " + hoverPosition.arrowBgPositionY
		});
	}

	collectScreenValues() {
		const values = {};

		const width = this.$icon.outerWidth();
		const height = this.$icon.outerHeight();
		const iconSizeBox = this.$icon[0].getBoundingClientRect();

		values.icon = {
			ViewportTop: iconSizeBox.top,
			ViewportLeft: iconSizeBox.left,
			Width: width,
			Height: height,
			HalfWidth: Math.ceil(width / 2),
			HalfHeight: Math.ceil(height / 2)
		};

		const $w = $(window);
		values.viewport = {
			Width: window.innerWidth || $w.width(),
			Height: window.innerHeight || $w.height(),
			ScrollTop: $w.scrollTop(),
			ScrollLeft: $w.scrollLeft()
		};
		values.distanceFromIconBound = {
			Left: values.icon.ViewportLeft,
			Right: values.viewport.Width - values.icon.ViewportLeft - values.icon.Width,
			Top: values.icon.ViewportTop,
			Bottom: values.viewport.Height - values.icon.ViewportTop - values.icon.Height
		};

		values.distanceFromIconCenter = {
			Left: values.distanceFromIconBound.Left + values.icon.HalfWidth,
			Right: values.distanceFromIconBound.Right + values.icon.HalfWidth,
			Top: values.distanceFromIconBound.Top + values.icon.HalfHeight,
			Bottom: values.distanceFromIconBound.Bottom + values.icon.HalfHeight
		};

		this.screenValues = values;
	}

	clearHoverStyles() {
		this.$popup
			.removeAttr("style")
			.removeClass(directionClass.top)
			.removeClass(directionClass.bottom)
			.removeClass(directionClass.left)
			.removeClass(directionClass.right);
	}

	guessHoverDirection() {
		const $hover = this.$popup,
			screenValues = this.screenValues;

		const distanceFromIconBound = screenValues.distanceFromIconBound;
		const viewport = screenValues.viewport;
		const icon = screenValues.icon;

		let hoverWidth;
		let hoverDirection = this.hoverDirection || "right";

		if (hoverDirection === "left" || hoverDirection === "right") {
			// Apply direction class in order to get proper hover width.
			$hover.addClass(directionClass.left);
			hoverWidth = $hover.outerWidth();

			// Check distance to Left and Right
			const suitsToLeft = distanceFromIconBound.Left + viewport.ScrollLeft >= hoverWidth;
			const suitsToRight = distanceFromIconBound.Right >= hoverWidth + pageScrollWidth;

			// If the hover can't be placed on horizontal direction we will try place it on the top direction.
			if (!suitsToLeft && !suitsToRight) {
				hoverDirection = "top";
				$hover.removeClass(directionClass.left);
				$hover.addClass(directionClass.top);
			}
		} else {
			// apply direction class in order to get proper hover height.
			$hover.addClass(directionClass.top);

			const hoverHeight = $hover.outerHeight();
			hoverWidth = $hover.outerWidth();

			const isScrollVisible = document.body.offsetHeight >= viewport.Height;

			//Check the availability of space at the top and bottom to display the Hover
			const suitsToTop = hoverHeight <= distanceFromIconBound.Top + viewport.ScrollTop;
			const suitsToBottom = isScrollVisible
				? hoverHeight >= viewport.ScrollTop - icon.ViewportTop - icon.Height
				: hoverHeight <= viewport.Height - distanceFromIconBound.Top - icon.HalfHeight;

			//Check whether you can display the hover right or left
			const suitsToHorizontalDirection = (distanceFromIconBound.Left - arrowHalfWidth) > hoverWidth
				|| (distanceFromIconBound.Right - arrowHalfWidth) > hoverWidth;

			//If the hover can't be placed on vertical direction and can be placed on horizontal direction
			//or the center of the icon is outside the right edge of the screen
			//or the center of the icon is outside the left edge of the screen
			if (!suitsToTop && !suitsToBottom && suitsToHorizontalDirection
				|| (screenValues.distanceFromIconCenter.Right - pageScrollWidth) <= 0
				|| screenValues.distanceFromIconCenter.Left <= 0) {
				hoverDirection = "right";
				$hover.removeClass(directionClass.top);
				$hover.addClass(directionClass.left);
			}
		}

		this.hoverDirection = hoverDirection;
	}

	getHoverPositionOnHorizontalAxis() {
		const distanceFromIconBound = this.screenValues.distanceFromIconBound;
		const distanceFromIconCenter = this.screenValues.distanceFromIconCenter;
		const viewport = this.screenValues.viewport;
		const icon = this.screenValues.icon;

		const hoverWidth = this.$popup.outerWidth();
		const hoverHeight = this.$popup.outerHeight();
		const hoverHalfHeight = Math.ceil(hoverHeight / 2);

		let hoverDocumentTop;
		let hoverDocumentLeft;
		let arrowBgPositionX = "100%";

		// Distance  to Top and  Bottom border is enough
		if (distanceFromIconCenter.Top >= hoverHalfHeight && distanceFromIconCenter.Bottom >= hoverHalfHeight) {
			hoverDocumentTop = viewport.ScrollTop + icon.ViewportTop + icon.HalfHeight - hoverHalfHeight;
			// Limiter adjustment top ( If the center of the icon is outside the top of the screen )
		} else if (distanceFromIconCenter.Top >= viewport.Height - icon.HalfHeight && distanceFromIconCenter.Top >= hoverHeight) {
			hoverDocumentTop = viewport.ScrollTop + icon.ViewportTop - hoverHeight + icon.HalfHeight;
			// Limiter adjustment bottom ( If the center of the icon is outside the bottom of the screen)
		} else if (distanceFromIconCenter.Top <= 0) {
			hoverDocumentTop = viewport.ScrollTop + distanceFromIconCenter.Top;
			// Distance to Top border is enough
		} else if (distanceFromIconCenter.Top >= hoverHeight) {
			hoverDocumentTop = viewport.ScrollTop + viewport.Height - hoverHeight;
		} else {
			hoverDocumentTop = viewport.ScrollTop;
		}

		const hoverVerticalMiddle = hoverDocumentTop + hoverHalfHeight;
		const iconVerticalMiddle = viewport.ScrollTop + icon.ViewportTop + icon.HalfHeight;
		const verticalMiddleDiff = hoverVerticalMiddle - iconVerticalMiddle;

		const arrowBgPositionY = `${hoverHalfHeight - verticalMiddleDiff - arrowHalfWidth}px`;

		const suitsToLeft = hoverWidth <= distanceFromIconBound.Left + viewport.ScrollLeft;
		const suitsToRight = hoverWidth <= distanceFromIconBound.Right;

		// If there is no place from left and on the right there         = true
		// If you have the right place, and hoverDirection === "right    = true
		// If there is no place from left and hoverDirection === "right  = true
		if (!suitsToLeft && suitsToRight
			|| suitsToRight && this.hoverDirection === "right"
			|| !suitsToLeft && this.hoverDirection === "right") {
			arrowBgPositionX = "0%";

			this.$popup.removeClass(directionClass.left);
			this.$popup.addClass(directionClass.right);

			hoverDocumentLeft = viewport.ScrollLeft + icon.ViewportLeft + icon.Width;
		} else {
			hoverDocumentLeft = viewport.ScrollLeft + icon.ViewportLeft - hoverWidth;
		}

		return {
			Top: hoverDocumentTop,
			Left: hoverDocumentLeft,
			arrowBgPositionX: arrowBgPositionX,
			arrowBgPositionY: arrowBgPositionY
		};
	}

	getHoverPositionOnVerticalAxis() {
		const distanceFromIconBound = this.screenValues.distanceFromIconBound;
		const distanceFromIconCenter = this.screenValues.distanceFromIconCenter;
		const viewport = this.screenValues.viewport;
		const icon = this.screenValues.icon;

		const hoverWidth = this.$popup.outerWidth();
		const hoverHeight = this.$popup.outerHeight();
		const hoverHalfWidth = Math.ceil(hoverWidth / 2);

		let hoverDocumentTop;
		let hoverDocumentLeft;
		let arrowBgPositionY = "100%";

		// Distance  to Left and Right border is enough
		if (distanceFromIconCenter.Left >= hoverHalfWidth && distanceFromIconCenter.Right >= hoverHalfWidth) {
			hoverDocumentLeft = viewport.ScrollLeft + icon.ViewportLeft + icon.HalfWidth - hoverHalfWidth;
			// If there is space on the left
		} else if (distanceFromIconCenter.Left >= hoverHalfWidth) {
			hoverDocumentLeft = viewport.ScrollLeft + viewport.Width - (hoverWidth + pageScrollWidth);
		} else {
			hoverDocumentLeft = viewport.ScrollLeft;
		}

		const hoverHorizontalMiddle = hoverDocumentLeft + hoverHalfWidth;
		const iconHorizontalMiddle = viewport.ScrollLeft + icon.ViewportLeft + icon.HalfWidth;
		const horizontalMiddleDiff = hoverHorizontalMiddle - iconHorizontalMiddle;

		const arrowBgPositionX = `${hoverHalfWidth - horizontalMiddleDiff - arrowHalfWidth}px`;
		// Check distance to Top
		const suitsToTop = hoverHeight <= distanceFromIconBound.Top + viewport.ScrollTop;

		// If there is no space at the top or hoverDirection = "bottom"
		if (!suitsToTop || this.hoverDirection === "bottom") {
			arrowBgPositionY = "0%";

			this.$popup.removeClass(directionClass.top);
			this.$popup.addClass(directionClass.bottom);

			hoverDocumentTop = viewport.ScrollTop + icon.ViewportTop + icon.Height;
		} else {
			hoverDocumentTop = viewport.ScrollTop + icon.ViewportTop - hoverHeight;
		}

		return {
			Top: hoverDocumentTop,
			Left: hoverDocumentLeft,
			arrowBgPositionX: arrowBgPositionX,
			arrowBgPositionY: arrowBgPositionY
		};
	}
}